"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiFlyingText = void 0;
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
var _pixi = require("pixi.js");
var _PixiSpineAnimation = require("./PixiSpineAnimation");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var INTRO_ANIM = "intro";
var LOOP_ANIM = "loop";
var OUTRO_ANIM = "outro";
var PixiFlyingText = exports.PixiFlyingText = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiFlyingText(name, pixiTextStyle) {
    var _this;
    _classCallCheck(this, PixiFlyingText);
    _this = _callSuper(this, PixiFlyingText, [name]);

    // initialize spine
    _defineProperty(_this, "_animation", void 0);
    _defineProperty(_this, "_textDisplay", void 0);
    var res = _core.CORE.loader.resources;
    _this._animation = new _PixiSpineAnimation.PixiSpineAnimation('special_text');
    _this.addChild(_this._animation);
    var state = _core.CORE.getState();

    // initialize text
    _this._textDisplay = new _pixi.Text("", pixiTextStyle);

    /*{
        strokeThickness: 8,
        stroke: 0xFFFFFF,
        fontFamily: ['font1', 'impact'],
        fontSize: fontSize || (state.config.channel === Channel.Desktop ? 120 * state.config.screenSize.scaleFactor : 54),
        fill: color || 0x3B7DE9,
        dropShadow: true,
        align: 'center'
    }*/

    if (_this._textDisplay.width > state.config.screenSize.width) {
      _this._textDisplay.scale.set(state.config.screenSize.width / _this._textDisplay.width);
    }
    _this.attachToSpine(_this._textDisplay);
    return _this;
  }
  _inherits(PixiFlyingText, _PixiGameComponent);
  return _createClass(PixiFlyingText, [{
    key: "playWithText",
    value: function playWithText(text) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        _this2._textDisplay.text = text;
        var len = text.length;
        if (len > 8) {
          // this._textDisplay.style.fontSize = 50;
        }
        _this2.play().then(function (complete) {
          _this2.parent.removeChild(_this2);
          _this2.removeChildren();
          _this2.destroy();
          resolve();
        });
      });
    }
  }, {
    key: "playTextWithDuration",
    value: function playTextWithDuration(text, duration) {
      var _this3 = this;
      if (!this._animation) return;
      var len = text.length;
      if (len > 8) {
        // this._textDisplay.style.fontSize = 50;
      }
      var _complete = false;
      this._textDisplay.text = text;
      this._animation.state.setAnimation(0, INTRO_ANIM, false);
      this._animation.state.addAnimation(0, LOOP_ANIM, true, 0);
      setTimeout(function () {
        return new Promise(function (resolve, reject) {
          _this3._animation.state.addListener({
            complete: function complete(entry) {
              if (!_complete) {
                _this3._animation.state.setAnimation(0, OUTRO_ANIM, false);
                _complete = true;
              } else {
                resolve(false);
              }
            }
          });
        }).then(function () {
          _this3.parent.removeChild(_this3);
          _this3.removeChildren();
          _this3.destroy();
        });
      }, duration);
    }
  }, {
    key: "attachToSpine",
    value: function attachToSpine(textDisplay) {
      var anim = this._animation;
      var fx1 = anim.slotContainers[anim.skeleton.findSlotIndex("text_add")]; // reference to spine slot
      var fx2 = anim.slotContainers[anim.skeleton.findSlotIndex("text_add2")]; // reference to spine slot
      var main = anim.slotContainers[anim.skeleton.findSlotIndex("text")]; // reference to spine slot
      var mask = anim.slotContainers[anim.skeleton.findSlotIndex("mask")]; // reference to spine slot

      var fxSprite1 = new _pixi.Sprite(textDisplay.texture);
      var fxSprite2 = new _pixi.Sprite(textDisplay.texture);
      var fxSprite3 = new _pixi.Sprite(textDisplay.texture);
      fxSprite1.blendMode = _pixi.BLEND_MODES.ADD;
      fxSprite2.blendMode = _pixi.BLEND_MODES.ADD;
      fxSprite3.blendMode = _pixi.BLEND_MODES.ADD;
      textDisplay.anchor.set(0.5, 0.5);
      fxSprite1.anchor.set(0.5, 0.5);
      fxSprite2.anchor.set(0.5, 0.5);
      fxSprite3.anchor.set(0.5, 0.5);
      textDisplay.scale.y = -1;
      fxSprite1.scale.y = -1;
      fxSprite2.scale.y = -1;
      fxSprite3.scale.y = -1;
      fx1.addChild(fxSprite1);
      fx2.addChild(fxSprite2);
      mask.addChild(fxSprite3);
      main.addChild(textDisplay);
    }
  }, {
    key: "play",
    value: function play() {
      var _this4 = this;
      if (!this._animation) return;
      var _complete2 = false;
      this._animation.state.setAnimation(0, INTRO_ANIM, false);

      //clean up self
      return new Promise(function (resolve, reject) {
        _this4._animation.state.addListener({
          complete: function complete(entry) {
            if (!_complete2) {
              _this4._animation.state.setAnimation(0, OUTRO_ANIM, false);
              _complete2 = true;
            } else {
              resolve(_complete2);
            }
          }
        });
      });
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiFlyingText.js.map